import React from "react";
import "./AboutHero.css";

const AboutHero = () => {
  return (
    <section className="about-hero-section">
      <div className="about-hero-content">
        <h1>
          About <span>Us</span>
        </h1>
        <p className="about-hero-description">
          Since 2000, the <strong>Development Education and Welfare Trust</strong> has empowered
          communities through education, welfare, and sustainable initiatives. Founded by
          <strong> Mr. Lucas Thapa</strong>, the trust focuses on social, cultural, economic, and
          educational development to create lasting positive change.
        </p>

        {/* Impact Stats */}
        <div className="about-hero-stats">
          <div className="stat-card">
            <h2>500+</h2>
            <p>Communities Supported</p>
          </div>
          <div className="stat-card">
            <h2>1,000+</h2>
            <p>Lives Impacted</p>
          </div>
          <div className="stat-card">
            <h2>5+</h2>
            <p>Years of Service</p>
          </div>
          <div className="stat-card">
            <h2>1+</h2>
            <p>Ongoing Programs</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
